import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { HandleErrorsService, SuperAdminService } from '../app-services';

export const superAdminResolver: ResolveFn<unknown> = () => {
  const superAdminService = inject(SuperAdminService);
  const handleErrors = inject(HandleErrorsService);

  return superAdminService.getSuperAdmin().pipe(
    map(s => s.data),
    catchError(err => {
      handleErrors.handleErrors(err);

      return throwError(() => err);
    }),
  );
};
